import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_p8rcsml9xr: FaireBrandEntity = {
  token: "b_p8rcsml9xr",
  type: "brand",
  name: "Lineage",
  avatarUrl:
    "https://cdn.faire.com/fastly/10c6c543fba4cb56ed38039147b056c998b2ea69a27e1a343da87c480e923bf7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/87ca584540d8d5a9e410f8f0280c9d73b7eabda4c80ac1b1411b36e0d89b3f50.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/10c6c543fba4cb56ed38039147b056c998b2ea69a27e1a343da87c480e923bf7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/87ca584540d8d5a9e410f8f0280c9d73b7eabda4c80ac1b1411b36e0d89b3f50.jpeg",
  location: "Richmond, VA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 95,
  isTopShop: true,
  isInsider: true,
  description:
    "Lineage was started out of a need for simple, everyday goods that are practical, elegant, and well-made. Started in late 2015 and based in Virginia, we design and make durable, timeless canvas and leather bags for everyday use. In 2019 we launched a line of soy candles and personal fragrance, inspired by nostalgic memories of travel, the outdoors, and our home in Virginia. Lineage is owned by a husband and wife duo, Paul and Jessica. Each of our items are made by hand in small batches in our studio in Richmond, Virginia, using American made materials and minimalist, eco friendly packaging.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:18.479Z",
    importedBy: "entity-db-cli",
  },
};
